// extracted by mini-css-extract-plugin
export default {"account":"User_account__Qejip","photo":"User_photo__IFUwt","logout":"User_logout__h5VGj"};